export default function BaseLayout({ children }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-[#14090c] to-black">
      {children}
    </div>
  );
}
